import React, { useEffect } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import {
  useCreatePianAtt,
  useDeletePianAtt,
  useGetPianAttById,
  useUpdatePianAtt,
  validationSchemaPianAtt,
} from "./Services";
import { PianAtt } from "./types";
import { FormField } from "../../common/FormField";
import {
  useFieldsAddPianAtt1,
  useFieldsAddPianAtt2,
  useFieldsAddPianAtt3,
  useFieldsAddPianAtt4,
} from "./FormAtt";
import dayjs, {Dayjs} from "dayjs";
import utc from "dayjs/plugin/utc";
import VersOreNoteAssist, {clampVersOreNote, loadVersOreCopilotConfig} from "../gestversore/VersOreNoteAssist";

interface EditPianAttProps {
  open: boolean;
  onClose: () => void;
  propidattivita: string;
  datainiziopian?: Date;
  datafinepian?: Date;
}

type PianAttForm = Yup.InferType<typeof validationSchemaPianAtt>;

const EditPianAtt: React.FC<EditPianAttProps> = ({
  open,
  onClose,
  propidattivita,
  datainiziopian,
  datafinepian,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm<PianAttForm>({
    resolver: yupResolver(validationSchemaPianAtt),
  });

  // console.log(errors);
  const selectedCodProg = watch("codprog");

    const { data: pianAttData } = useGetPianAttById(propidattivita);

  const { mutateAsync: updatePianAtt, isPending: isUpdating } =
    useUpdatePianAtt();
  const { mutateAsync: deletePianAtt, isPending: isDeleting } =
    useDeletePianAtt();
  const {  mutateAsync: createPianAtt,  isPending: isCopying,} =
      useCreatePianAtt();

const keycoddip = localStorage.getItem("keycoddip") || "";
const keyrole = localStorage.getItem("keyrole") || "";

const isCalendarMove = !!datainiziopian && !!datafinepian;

// console.log(datafinepian);


// const isAdmin = keyrole.includes('TimeReportAdmin');
const isAdmin =
  keyrole.includes('TimeReportAdmin') ||
  keyrole.includes('TimeReportPianAtt');

const isRef = pianAttData?.ref === keycoddip;
const isOwner = pianAttData?.coddip === keycoddip;
const noRef = (pianAttData?.ref ?? '').toUpperCase() === 'NN';

const canEdit =  isAdmin ||  isRef ||  noRef && isOwner;
const canEditPercompOnly = isAdmin || isRef || isOwner;




let filterProgs = '';

//se admin o non puo edit (not admin o ref) visulizza tutti i progetti
if (isAdmin || !canEdit) {
  filterProgs = 'editAdminProgs';
} else {
  filterProgs = 'editRefProgs';
}

// console.log("canEdit:",canEdit);
// console.log("canEditPercompOnly:",canEditPercompOnly);
// console.log("filterProgs:",filterProgs);


  let f1 = useFieldsAddPianAtt1(canEdit);
  let f2 = useFieldsAddPianAtt2(selectedCodProg,filterProgs,canEdit,setValue);
  let f3 = useFieldsAddPianAtt3(canEditPercompOnly);
  let f4 = useFieldsAddPianAtt4(selectedCodProg,canEdit);



  /* ===================== INIT FORM ===================== */



// const normalizeDate = (
//   d?: Date | null
// ): Date | undefined => (d instanceof Date ? d : undefined);
//
// useEffect(() => {
//   if (!pianAttData) return;
//
//   reset({
//     ...pianAttData,
//
//     // DATE PIANIFICATE (da calendario o backend)
//     datainiziopian:
//       normalizeDate(datainiziopian) ??
//       normalizeDate(pianAttData.datainiziopian),
//
//     datafinepian:
//       normalizeDate(datafinepian) ??
//       normalizeDate(pianAttData.datafinepian),
//
//     // DATE EFFETTIVE (SEMPRE NORMALIZZATE)
//     datainizioeff: normalizeDate(pianAttData.datainizioeff),
//     datafineeff: normalizeDate(pianAttData.datafineeff),
//   });
// }, [pianAttData, datainiziopian, datafinepian, reset]);


dayjs.extend(utc);

const normalizeDate = (d?: Date | string | null): Date | undefined => {
  if (!d) return undefined;
  const date = d instanceof Date ? d : new Date(d);
  return isNaN(date.getTime()) ? undefined : date;
};

useEffect(() => {
  if (!pianAttData) return;

  const normalizeDate = (d?: Date | string | null): Date | undefined => {
    if (!d) return undefined;
    const date = d instanceof Date ? d : new Date(d);
    return isNaN(date.getTime()) ? undefined : date;
  };

  const dbStart = normalizeDate(pianAttData.datainiziopian);
  const dbEnd = normalizeDate(pianAttData.datafinepian);

  const propStart = normalizeDate(datainiziopian);
  const propEnd = normalizeDate(datafinepian);


  const useProps = propStart && propEnd;

  const start = useProps ? propStart : dbStart;
  const end = useProps ? propEnd : dbEnd;

  const isMonthDrag =
  useProps &&
  propStart.getHours() === 0 &&
  propStart.getMinutes() === 0 &&
  propEnd.getHours() === 0 &&
  propEnd.getMinutes() === 0;





  let safeEnd = end;
  if (start && (!safeEnd || safeEnd.getTime() < start.getTime())) {
    safeEnd = new Date(start.getTime() + 60 * 60 * 1000);
  }

  reset({
    ...pianAttData,

    datainiziopian: start,
    datafinepian: safeEnd,

  orainiz: isMonthDrag
  ? pianAttData.orainiz
  : useProps && start
  ? start.getHours()
  : pianAttData.orainiz,

    mininiz: isMonthDrag
  ? pianAttData.mininiz
  : useProps && start
  ? start.getMinutes()
  : pianAttData.mininiz,

orafine: isMonthDrag
  ? pianAttData.orafine
  : useProps && end
  ? end.getHours()
  : pianAttData.orafine,

minfine: isMonthDrag
  ? pianAttData.minfine
  : useProps && end
  ? end.getMinutes()
  : pianAttData.minfine,



    datainizioeff: normalizeDate(pianAttData.datainizioeff),
    datafineeff: normalizeDate(pianAttData.datafineeff),
  });

}, [pianAttData, datainiziopian, datafinepian, reset]);


  const onSubmit: SubmitHandler<PianAttForm> = async (data) => {
    const copilotConfig = await loadVersOreCopilotConfig();
    await updatePianAtt({
      ...data,
      ref: data.ref === 'NN'  ? keycoddip  : data.ref,
      note: clampVersOreNote(data.note || '', copilotConfig.noteMaxLength).value,
    } as PianAtt);
    onClose();
  };

  const handleCopy: SubmitHandler<PianAttForm> = async (data) => {
  const copilotConfig = await loadVersOreCopilotConfig();

  const payload: any = {
    ...data,

    ref: data.ref === 'NN'
      ? keycoddip
      : data.ref,

    note: clampVersOreNote(
      data.note || '',
      copilotConfig.noteMaxLength
    ).value,
  };

  // Never copy the database ID
  delete payload.id;
  delete payload.idattivita;

  await createPianAtt(payload as PianAtt);

  onClose();
};

  const handleDelete = async () => {
    const id = Number(propidattivita);
    if (!id || isNaN(id)) return;

    if (
      window.confirm(
        `ATTENZIONE!\nVuoi eliminare definitivamente l'attività ${id}?`
      )
    ) {
      await deletePianAtt(id);
      onClose();
    }
  };

  /* ===================== UI ===================== */

  return (
    <Dialog open={open}  onClose={isDeleting ? undefined : onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        <Typography variant="h6">Modifica Attività ID: {propidattivita} REF: {pianAttData?.ref}  </Typography>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}   sx={{
    pointerEvents: isDeleting ? 'none' : 'auto',
    opacity: isDeleting ? 0.6 : 1,
  }}>
            <Stack direction="row" spacing={2}>{f1.map(f => <FormField key={String(f.name)} control={control} field={f} />)}</Stack>
            <Stack direction="row" spacing={2}>
                {f2.map(f => <FormField key={String(f.name)} control={control} field={f} />)}
                {f3.map(f => <FormField key={String(f.name)} control={control} field={f} />)}
            </Stack>
            <Stack direction="row" spacing={2}>{f4.map(f => <FormField key={String(f.name)} control={control} field={f} />)}</Stack>
            <Controller
              name="note"
              control={control}
              render={({ field, fieldState }) => (
                <VersOreNoteAssist
                  textFieldId="pian-att-edit-note"
                  value={String(field.value || '')}
                  onChange={field.onChange}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  disabled={!canEdit}
                  rows={3}
                />
              )}
            />
            <Stack
                direction="row"
                justifyContent="flex-end"
                spacing={2}
              >
                <Button
                  color="error"
                  variant="contained"
                  onClick={handleDelete}
                  disabled={
                    isDeleting ||
                    isUpdating ||
                    isCopying ||
                    !canEdit
                  }
                >
                  {isDeleting ? "Eliminazione…" : "Elimina"}
                </Button>

                <Button
                  onClick={onClose}
                  variant="outlined"
                  color="error"
                  disabled={
                    isDeleting ||
                    isUpdating ||
                    isCopying
                  }
                >
                  Annulla
                </Button>

                {isCalendarMove && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(handleCopy)}
                    disabled={
                      !canEdit ||
                      isUpdating ||
                      isCopying ||
                      isDeleting
                    }
                  >
                    {isCopying ? "Copiando…" : "Copia"}
                  </Button>
                )}

                <Button
                  type="submit"
                  variant="contained"
                  disabled={
                    (!canEdit && !canEditPercompOnly) ||
                    isUpdating ||
                    isCopying ||
                    isDeleting
                  }
                >
                  {isUpdating
                    ? "Salvando…"
                    : isCalendarMove
                    ? "Sposta"
                    : "Salva"}
                </Button>
              </Stack>


          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditPianAtt;
